import React, { useEffect, useMemo, useState } from 'react'
// import { GigStepProperty, GigStepPropertyWithValue, Milestone, MilestoeStep, MilestonSpecifications } from '../../../types/collaborations/CollaborationTypes';

import Choice from './form/Choice';
import { useParams } from 'react-router-dom';
// import { submitMilestoneStep } from '../../../services/api/collaboration';
import inModal from 'utils/hoc/inModal';
import { RootState, store } from 'store';
import { usePrivileges } from 'hooks/useAuth';
import { PRIVILEGE } from 'constants/privilege';
import FormFields from './form/FormFields';
import { getSignedGCSUploadURL, linkGCSFileWithMilestoneStep, processCollaborationMilestoneStep, uploadLargeFileInChunks } from 'services/api/collaboration';
import { Milestone, MilestoneStep, GigStepPropertyWithValue } from 'types/collaboration';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

interface FormBuilderProps {
    title: string,
    isActive: boolean,
    onClose: (refetch?: boolean) => void,
    activeMilestone: Milestone,
    step: MilestoneStep,
}



const FormBuilder: React.FC<FormBuilderProps> = ({ activeMilestone, step, onClose }) => {
    const selectedHubId = useSelector((state: RootState) => state.auth.selectedHubId);
    const privileges = usePrivileges();
    const [largeFilesUploadProgress, updateLargeFileUploadProgress] = useState<{[key: string]: number}>({});

    const [properties, setProperties] = useState<GigStepPropertyWithValue[]>([]);

    const { campaignId, influencerId, milestoneId } = useParams();

    const [submitting, setSubmitting] = useState(false);

    const isValid = () => {
        for (let property of properties) {
            if(['approval'].includes(property.key)) continue;
            if (property.mandatory && !property.value) return false;
        }

        return true;
    }

    // useEffect(() => {
    //     if(disableBackdropClick)
    //         disableBackdropClick(submitting)
    // }, [submitting])

    const validateForm = () => {
        let hasErrors = false
        let updated_properties = [...properties]
        for (let i in updated_properties) {
            if (updated_properties[i].mandatory && !updated_properties[i].value) {
                updated_properties[i] = { ...updated_properties[i], error: `${updated_properties[i].label} is required.` }
                hasErrors = true;
            }
        }

        if(hasErrors){
            setProperties(updated_properties);
        }

        return hasErrors;
    }

    const setLargeFileUploadProgress = (propertyKey: string, progress: number) => {
        updateLargeFileUploadProgress((prev) => ({
            ...prev,
            [propertyKey]: progress
        }));
    }

    const onSubmit = async () => {
        const isValid = !(validateForm());
        if (!isValid || !campaignId || !influencerId || !milestoneId || !selectedHubId) return;

        setSubmitting(true);

        let data: any = {};

        for (let property of properties) {
            if(property.type === 'choice' && typeof property.value !== 'string' && typeof property.value === 'object'){
                for(let [key, value] of Object.entries(property.value)){
                    data[`${property.key}[${key}]`] = value;
                }
            }else{
                data[property.key] = property.value;
            }
            if (property.type === 'large_file' && property.value instanceof File) {
                const file = property.value;
                const content_type = file.type;
                const extension = file.name.split('.').pop()?.toLowerCase() ?? '';
                const signedGCSData = await getSignedGCSUploadURL(selectedHubId, campaignId, influencerId, {extension, content_type});
                await uploadLargeFileInChunks(file, signedGCSData.upload_url, (progress) => setLargeFileUploadProgress(property.key, progress.percentage));
                await linkGCSFileWithMilestoneStep(selectedHubId, campaignId, influencerId, {uuid: signedGCSData.uuid, extension, content_type, step: step.gig_step.slug});
                data[property.key] = signedGCSData.uuid;
            }
        }

        try {
            setSubmitting(true);
            await processCollaborationMilestoneStep(selectedHubId, campaignId, influencerId, milestoneId, {step: step.gig_step.slug, ...data});
            onClose(true);
        } catch (error:any) {
            console.log(error);
            toast.error(error?.response?.data?.message ?? "Unknown error occurred.")
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <div className='form-builder-form'>
            <FormFields step={step} activeMilestone={activeMilestone} onChange={(updatedProperties) => setProperties(updatedProperties)} largeFilesUploadProgress={largeFilesUploadProgress} />
            <div className="milestone-step-actions">
                <button className="theme-btn theme-btn-primary-outlined" onClick={() => onClose()}>Cancel</button>
                <button className="theme-btn theme-btn-primary" disabled={!isValid() || submitting || !privileges.includes(PRIVILEGE.CAMPAIGN.COLLABORATION.PROCESS)} onClick={onSubmit}>Submit</button>
            </div>
        </div>
    )
}

const FormBuilderModal: React.FC<FormBuilderProps> = (props) => {
    const { title } = props;

    const ModalComponent = useMemo(() => inModal(FormBuilder, title), [title])

    return <ModalComponent {...props} />
}

export default FormBuilderModal;